var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bold/mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.84045 2.66697C2.45805 2.65734 2.0869 2.79691 1.80563 3.05615C1.52435 3.31539 1.35503 3.67394 1.3335 4.05586V11.3406C1.3335 11.7826 1.50909 12.2065 1.82165 12.5191C2.13421 12.8316 2.55813 13.0072 3.00016 13.0072H13.0001C13.2193 13.0081 13.4364 12.9657 13.639 12.8822C13.8417 12.7988 14.0257 12.6761 14.1807 12.5211C14.3356 12.3662 14.4584 12.1821 14.5418 11.9795C14.6253 11.7768 14.6677 11.5597 14.6668 11.3406V4.06279C14.647 3.68148 14.4792 3.32298 14.199 3.06357C13.9189 2.80416 13.5485 2.66434 13.1668 2.6739L2.84045 2.66697ZM4.29876 5.3753C4.11458 5.25282 3.88931 5.20852 3.67247 5.25214C3.45564 5.29577 3.26501 5.42375 3.14253 5.60793C3.02005 5.79211 2.97575 6.0174 3.01938 6.23424C3.06301 6.45108 3.19098 6.6417 3.37516 6.76418L7.54182 9.54195C7.67828 9.63391 7.83908 9.68303 8.00363 9.68303C8.16818 9.68303 8.32896 9.63391 8.46542 9.54195L12.6321 6.76418C12.8163 6.6417 12.9443 6.45108 12.9879 6.23424C13.0315 6.0174 12.9872 5.79211 12.8647 5.60793C12.7423 5.42375 12.5516 5.29577 12.3348 5.25214C12.1179 5.20852 11.8927 5.25282 11.7085 5.3753L8.00016 7.84751L4.29876 5.3753Z",
    fill: "#6B4924"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOrange);
export default __webpack_public_path__ + "static/media/email-orange.924cce5822188dddcaa6d75cb58e2a03.svg";
export { ForwardRef as ReactComponent };